import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import inventoryListModel from '@/models/inventory/inventory-list'
import store from '@/store'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import {
  getCurrentInstance,
  onBeforeMount,
  reactive,
  watch,
} from '@vue/composition-api'

export default function useAssignInventoryModal(props) {
  const vm = getCurrentInstance().proxy
  const { fetchInventoryList } = inventoryListModel()
  const { pagination, onPageChange } = usePagination()
  const { filters, ordering, onSetValueSearch } = useFilterHeaderTable()
  const { openDefaultErrorModal, openErrorModal } = useValidationModal()

  const privilegeDetail = reactive({
    name: '',
    privilegeId: '',
    inventoryEntry: [],
  })

  const loading = reactive({
    tableData: false,
    tableOverlay: false,
  })

  const inventoryList = reactive({
    payload: [],
  })

  const fields = [
    { key: 'seq', label: 'No.' },
    { key: 'name', label: 'Inventory Name' },
    { key: 'alt_reference', label: 'Reference' },
    { key: 'actions', label: '' },
  ]

  const fetchAssignInventory = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true
    }
    fetchInventoryList.payload.Page = pagination.currentPage
    fetchInventoryList.payload.Limit = pagination.perPage
    fetchInventoryList.payload.Filters = filters
    fetchInventoryList.payload.Ordering = ordering.value
    store
      .dispatch('api/apiRequest', fetchInventoryList)
      .then(response => {
        inventoryList.payload = response.data.payload
        pagination.rows = response.data.payload.length
        pagination.totalRows = response.data.filtered_record
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
        loading.tableOverlay = false
      })
  }

  const resolveAssignInventory = inventory => {
    if (privilegeDetail.inventoryEntry) {
      return (
        privilegeDetail.inventoryEntry.filter(
          elem => elem == inventory.inventory_id,
        ).length > 0
      )
    }
    return false
  }

  const getPrivilegeDetail = () => {
    // ต้อง build แบบนี้ส่งมา
    // props.privilegeObj = {inventory_entry : [2,3]}
    if (props.privilegeObj.hasOwnProperty('inventory_entry')) {
      privilegeDetail.name = props.privilegeObj.name_en
      privilegeDetail.privilegeId = props.privilegeObj.privilege_id
      if (props.privilegeObj.inventory_entry) {
        privilegeDetail.inventoryEntry = [...props.privilegeObj.inventory_entry]
      }
    }
  }

  const onAssignInventory = inventory => {
    loading.tableOverlay = true
    privilegeDetail.inventoryEntry.push(inventory.inventory_id)
    vm.$emit('onSelectAssignInventory', inventory)
    setTimeout(() => {
      loading.tableOverlay = false
    }, 300)
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchAssignInventory()
      }
    },
    { deep: true },
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchAssignInventory()
    },
    { deep: true },
  )

  const onModalOpen = () => {
    // ToDo
  }

  onBeforeMount(() => {
    getPrivilegeDetail()
    fetchAssignInventory()
  })

  return {
    fields,
    loading,
    inventoryList,
    onModalOpen,
    pagination,
    onPageChange,
    onSetValueSearch,
    privilegeDetail,
    resolveAssignInventory,
    onAssignInventory,
  }
}
